if (!customElements.get('td-modal')) {
  class TdModal extends HTMLElement {
  
    constructor() {
      super();
      this.MODAL_TRIGGERS = [];
      this.ACTIVE_CLASS = 'td-active';
    }
  
    connectedCallback() {
      // Find modal close elements within this modal
      this.MODAL_CLOSE_ELMS = this.querySelectorAll('[data-modal-close]');
      
      // Get the trigger ID for this modal
      const triggerId = this.getAttribute('data-trigger-id');
      if (triggerId) {
        // Find triggers that match this modal's trigger ID
        this.MODAL_TRIGGERS = document.querySelectorAll(`[data-modal-trigger="${triggerId}"]`);
      }
      
      this.attachListeners();
    }
  
    attachListeners() {
      // Add event listeners to modal triggers if they exist
      if (this.MODAL_TRIGGERS.length > 0) {
        this.MODAL_TRIGGERS.forEach((trigger) => {
          trigger.addEventListener('click', this.openModal.bind(this));
        });
      }

      // Add event listeners to close elements
      if (this.MODAL_CLOSE_ELMS.length > 0) {
        this.MODAL_CLOSE_ELMS.forEach((close) => {
          close.addEventListener('click', this.closeModal.bind(this));
        });
      }

      // Add keyboard event listener for ESC key
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.classList.contains(this.ACTIVE_CLASS)) {
          this.closeModal(event);
        }
      });
    }

    openModal(e) {
      if (e) {
        e.preventDefault();
      }
      this.classList.add(this.ACTIVE_CLASS);
      document.body.style.overflow = 'hidden'; // Prevent scrolling when modal is open
    }

    closeModal(e) {
      if (e) {
        e.preventDefault();
      }
      this.classList.remove(this.ACTIVE_CLASS);
      document.body.style.overflow = ''; // Restore scrolling
    }
  }
  
  customElements.define('td-modal', TdModal);
}
